import React, { Component } from 'react';

import PasswordResetRequestModalComponent from './PasswordResetRequestModalComponent';

export default class PasswordResetRequestModalContainer extends Component {
  render = () => {
    const { isOpen, onRequestClose } = this.props;
    return (
      <PasswordResetRequestModalComponent
        isOpen={isOpen}
        onRequestClose={onRequestClose}
      />
    );
  }
}